import Cookies from 'js-cookie';
import {
    IS_FORCE_DISABLE_SILENT_AUTH,
    IS_IFRAME,
    IS_MOBILE_BROWSER,
    IS_NEED_SILENT_AUTH,
    IS_PUBLIC,
    IS_VKT_WEBVIEW,
} from 'reactApp/appHelpers/configHelpers';

export function initMyTeam() {
    const hasMyTeamCookie = !!Cookies.get('isMyTeam');
    if (IS_VKT_WEBVIEW && !hasMyTeamCookie && !IS_PUBLIC) {
        Cookies.set('isMyTeam', 'true', { path: '/' });
    }

    const hasNeedSilentAuthCookie = !!Cookies.get('isNeedSilentAuth');

    if (IS_VKT_WEBVIEW && IS_NEED_SILENT_AUTH && !hasNeedSilentAuthCookie) {
        Cookies.set('isNeedSilentAuth', 'true', { path: '/' });
    }

    if (IS_FORCE_DISABLE_SILENT_AUTH) {
        Cookies.remove('isNeedSilentAuth', { path: '/' });
    }

    const userAgent = window.navigator.userAgent;

    if (!userAgent.includes('QtWebEngine')) {
        if (IS_MOBILE_BROWSER && !IS_IFRAME) {
            return;
        }
        Cookies.remove('isMyTeam', { path: '/' });
        Cookies.remove('isNeedSilentAuth', { path: '/' });
    }
}
